import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../services/auth/authentication.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private AuthHeader = 'Authorization';
  private token: string;

  constructor(
    private authService: AuthenticationService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const skipAuth = this.isPublicAuthRequest(request.url);
    const user = !skipAuth && localStorage.getItem('currentUser')
      ? JSON.parse(localStorage.getItem('currentUser'))
      : null;

    this.token = user ? this.normalizeToken(user.token) : null;
    request = this.addAuthenticationToken(request);

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (!skipAuth) {
          this.authService.handleUnauthorizedError(error);
        }
        return throwError(error);
      })
    );
  }

  /** Rutas públicas: no enviar JWT (un token viejo grande provoca 400 en Apache). */
  private isPublicAuthRequest(url: string): boolean {
    const publicPaths = [
      '/auth/signin',
      '/auth/admin/signin',
      '/auth/signup',
      '/auth/citizen-signup',
      '/auth/citizen-identify',
      '/auth/citizen-lookup',
      '/auth/set-password',
      '/auth/reset',
      '/auth/changePassword',
      '/auth/updatePassword',
    ];
    return publicPaths.some((path) => url.includes(path));
  }

  private normalizeToken(raw: string | null | undefined): string | null {
    if (!raw || typeof raw !== 'string') {
      return null;
    }
    const token = raw.replace(/^Bearer\s+/i, '').trim();
    return token || null;
  }

  private addAuthenticationToken(request: HttpRequest<any>): HttpRequest<any> {
    if (!this.token || this.isPublicAuthRequest(request.url)) {
      return request;
    }

    return request.clone({
      headers: request.headers.set(this.AuthHeader, this.token)
    });
  }
}
